export enum TrackedPairsSourceType {
  Audience = 1,
  Segment = 2,
}

export interface TrackedPairsConfig {
  sourceType: TrackedPairsSourceType;
  sourceId: number;
  goalId: number;
}

export interface TrackedPair extends TrackedPairsConfig {
  id: number;
}
